var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 7
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.743.793l.707.707L5.5 6.45.55 1.5l.707-.707L5.5 5.036 9.743.793z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMTEiCiAgaGVpZ2h0PSI3IgogIHZpZXdCb3g9IjAgMCAxMSA3IgogIHRyYW5zZm9ybT0icm90YXRlKDApIgo+CiAgPHBhdGgKICAgIGZpbGw9ImN1cnJlbnRDb2xvciIKICAgIGZpbGxSdWxlPSJldmVub2RkIgogICAgZD0iTTkuNzQzLjc5M2wuNzA3LjcwN0w1LjUgNi40NS41NSAxLjVsLjcwNy0uNzA3TDUuNSA1LjAzNiA5Ljc0My43OTN6IgogID48L3BhdGg+Cjwvc3ZnPg==";
export { SvgChevronBottom as ReactComponent };